import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const audienceTimelinePartCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:contents}.audience-timeline-part{display:flex;align-items:center;justify-content:center;font-family:var(--tt-font-default);font-size:var(--tt-font-size-2xs)}.audience-timeline-part[data-part-type=live],.audience-timeline-part[data-part-type=ondemand]{background-color:var(--tt-color-green-400);color:var(--tt-color-white);border-radius:50%;height:16px;width:16px}.audience-timeline-part[data-part-type=none]{background-color:var(--tt-color-gray-400);color:var(--tt-color-white);border-radius:50%;height:10px;width:10px}";

const AudienceTimelinePart = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.type = 'none';
    this.number = 0;
  }
  render() {
    return (h("div", { "data-part-type": this.type, class: "audience-timeline-part" }, this.type !== 'none' && this.number));
  }
  static get style() { return audienceTimelinePartCss; }
}, [1, "tt-audience-timeline-part", {
    "type": [1],
    "number": [2]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-audience-timeline-part"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-audience-timeline-part":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, AudienceTimelinePart);
      }
      break;
  } });
}

const TtAudienceTimelinePart = AudienceTimelinePart;
const defineCustomElement = defineCustomElement$1;

export { TtAudienceTimelinePart, defineCustomElement };
